<template>
  <div class="page-login" v-loading="loading">
    <div class="body">
      <div class="title">{{ Config.SYSTEM_TITLE }}</div>
      <form @submit.prevent="doLogin">
        <el-input placeholder="用户名" v-model="form.username" :maxlength="50">
          <i slot="prefix" class="iconfont iconmy"></i>
        </el-input>
        <el-input
          placeholder="密码"
          v-model="form.password"
          type="password"
          :maxlength="50"
        >
          <i slot="prefix" class="iconfont iconsuo"></i>
        </el-input>
        <el-checkbox v-model="remember" style="margin-bottom: 10px"
          >记住密码</el-checkbox
        >
        <el-button native-type="submit" type="primary">登录</el-button>
      </form>
      <!-- <div class="login_footer">
        Copyright © 2020 重庆恩谷信息科技有限公司 . All Rights Reserved.
      </div> -->
        <div
      class="login_footer"
      style="position: absolute; bottom: 5px; width: 100%; text-align: center"
    >
      <div style="width: 800px; margin: 0 auto">
        <div
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
          "
        >
          <img src="../../assets/images/login.png" style="float: left" />
          <p
            style="
              float: left;
              height: 20px;
              line-height: 20px;
              margin: 0px 0px 0px 5px;
              color: #000;
            "
          >
            <a  style=" text-decoration: none;
      font-size: 14px;
      color: #999;"
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502013857"
            >
              沪公网安备 31011502013857号
            </a>
            &nbsp; &nbsp;
            <a  style=" text-decoration: none;
      font-size: 14px;
      color: #999;" target="_blank" href="https://beian.miit.gov.cn/"
              >沪ICP备13026006号-5 </a
            >&nbsp; &nbsp;
          </p>
        </div>
      </div>
      <div style="font-size: 14px;color: rgb(153, 153, 153);">
        <p>Copyright © 2020 上海恩谷信息科技有限公司. All Rights Reserved.</p>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import loginCookie from "@/utils/cookie.js"
export default {
  data() {
    return {
      remember: false,
      loading: false,
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    doLogin() {
      var vm = this
      this.loading = true
      if (vm.remember) {
        let accountInfo = vm.form.username + "&" + vm.form.password;
        loginCookie.setCookie('callCenterInfo', accountInfo, 1440 * 3)
      }
      //没有勾选  删除cookie
      else {
        loginCookie.delCookie('callCenterInfo');
      }
      this.Service.login(this.form.username, this.form.password).then(() => {
        this.routeReplace({ path: '/' })
      }).catch(err => {

        let str = err.data.des;
        if (str == "success" && err.data.userRole != 16) {
          str = "用户权限不足"
        }
        this.$message.error(`${str}`)
      }).finally(() => {
        this.loading = false
      })
    },
    loadAccountInfo() {
      var vm = this;
      let accountInfo = loginCookie.getCookie("callCenterInfo")
      if (Boolean(accountInfo) === false) {
        vm.remember = false
        return false
      }
      else {
        let index = accountInfo.indexOf('&');
        vm.form.username = accountInfo.substring(0, index)
        vm.form.password = accountInfo.substring(index + 1)
        vm.remember = true
      }
    }
  },
  mounted() {
    this.loadAccountInfo()
  }
}
</script>
